<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 800px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Activity Users List</h3>
      <div class="header-actions">
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body">
      @if (usersLoading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i></div>
}
      @if (!usersLoading) {
<div>
        <div class="row" style="margin-bottom: 8px;">
          <div class="col-md-4 pull-right">
            <input type="text" class="form-control input-sm" [(ngModel)]="userSearchText" [ngModelOptions]="{standalone: true}" placeholder="User Search">
          </div>
        </div>
        <div style="max-height: 420px; overflow: auto;">
          <table class="table table-bordered table-striped table-condensed">
            <thead><tr><th>User Name</th><th>User Role</th><th>Assigned Through</th></tr></thead>
            <tbody>
              @for (item of filteredUserList(); track $index) {
<tr>
                <td>{{item.USER_NAME}}</td><td>{{item.USER_ROLE}}</td><td>{{item.ASSIGNED_THROUGH}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}
    </div>
    <div class="modal-footer">
      <button class="btn btn-info btn-sm" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
